// @ts-nocheck

export function additionalInfoState(component, response, update_msg) {
  component.setState({
    loading: false,
  });
  update_msg(true, response.msg, false);
}
export function updateSplitCountState(response, update_msg) {
  update_msg(true, response.msg, false);
}
export function fetchTutorsState(component, response) {
  let state = {
    loading: false,
    requestPool: response.tutors,
    teachAllSubjects: Boolean(response.teach_all_subjects),
    split_count: response.split_count,
    selectCurrency: response.selectCurrency || component.selectCurrency,
    // totalBudget: response.totalBudget || component.totalBudget,
    // hourlyBudget: response.hourlyBudget || component.hourlyBudget,
    convertedTotalBudget: response.convertedTotalBudget || component.convertedTotalBudget,
    convertedHourlyBudget: response.convertedHourlyBudget || component.convertedHourlyBudget,
  };
  // component.setState({
  //   loading: false,
  //   requestPool: response.tutors,
  // });
  response.tutors.map((pool) => {
    if (!pool.approved) {
      return pool;
    }
    for (var i = 0; i < pool.matched_subjects.length; i++) {
      if (pool.matched_subjects[i].active) {
        state.isOneActive = true;
        // component.setState({ isOneActive: true });
        break;
      }
    }
    return pool;
  });
  component.setState(state);
}
export function updateBudgetState(component, response) {
  component.setState({
    message: { status: true, text: response.msg },
    totalBudget: response.new_budget,
    hourlyBudget: response.hourly_price,
  });
}
export function convertBudgetState(component, response) {
  component.setState({
    convertedBudget: response.new_converted_Budget,
    convertedHourlyPrice: response.new_converted_hourly_price,
  })
}
export function updateCurrencyState(component, response) {
  component.setState({
    message: { status: true, text: response.msg },
    currency: response.new_currency,
  })
}
export function tutorApprovalState(component, set_data, response, update_msg) {
  component.setState({
    loading: false,
    approved: set_data,
  });
  update_msg(true, response.msg, false);
}
export function poolInstanceState(component, response, update_msg) {
  // component.setState({
  //   loading: false,
  // });
  // update_msg(true, response.msg, false);
  component.setState({
    loading: false,
  });
  update_msg(true, response.msg, false);
}
export function profileToClientState(component, response, update_msg) {
  component.setState({
    // sending: false,
    // sent: true,
    message: { status: true, text: response.msg },
  });
  // update_msg(true, response.msg, false);
}
let setResponseState = (
  action,
  response,
  component,
  set_data,
  update_msg = null,
) => {
  switch (action) {
    case "fetchTutors":
      fetchTutorsState(component, response);
      // component.setState({
      //   loading: false,
      //   requestPool: response.tutors,
      // });
      // response.tutors.map((pool) => {
      //   if (!pool.approved) {
      //     return pool;
      //   }
      //   for (var i = 0; i < pool.matched_subjects.length; i++) {
      //     if (pool.matched_subjects[i].active) {
      //       component.setState({ isOneActive: true });
      //       break;
      //     }
      //   }
      //   return pool;
      // });
      break;
    case "tutorApproval":
      tutorApprovalState(component, set_data, response, update_msg);
      // component.setState({
      //   loading: false,
      //   approved: set_data,
      // });
      // update_msg(true, response.msg, false);
      break;
    case "updatePrice":
      poolInstanceState(component, response, update_msg);
      // component.setState({
      //   loading: false,
      // });
      // update_msg(true, response.msg, false);
      break;
    case "updateAdditionalInfo":
      additionalInfoState(component, response, update_msg);
      break;
    case "updateSplitCount":
      updateSplitCountState(response, update_msg);
      break;
    case "updateBudget":
      updateBudgetState(component, response);
      // component.setState({
      //   message: { status: true, text: response.msg },
      //   totalBudget: response.new_budget,
      //   hourlyBudget: response.hourly_price,
      // });
      break;
    case "updateCurrency":
      updateCurrencyState(component, response);
      break;
    case "convertBudget":
      convertBudgetState(component, response);
      break;
    case "addTutorToClientPool":
      profileToClientState(component, response);
      // component.setState({
      //   sending: false,
      //   sent: true,
      //   message: { status: true, text: response.msg },
      // });
      break;
    case "updateDefaultSubject":
      poolInstanceState(component, response, update_msg);
      // component.setState({
      //   loading: false,
      // });
      // update_msg(true, response.msg, false);
      break;
    default:
      console.log("value can't be caught");
  }
};

let handleErrorMessage = (
  status,
  text,
  action,
  component,
  update_msg = null,
) => {
  switch (status) {
    case 0:
    case 400:
    case 401:
    case 404:
    case 500:
      component.setState({
        message: { status: true, text: text, error: true },
        loading: false,
        sent: false,
        sending: false,
      });
      if (update_msg) update_msg(true, text, true);
      break;
    default:
      break;
  }
};

let rawSendToServer = (
  baseUrl,
  admin_user_id,
  url,
  method = "POST",
  data,
  action,
  component,
  set_data = null,
  update_msg = null,
) => {
  let fetch_ = null;
  if (method === "GET") {
    let query = `?user_id=${admin_user_id}&${data}`;
    fetch_ = fetch(`${baseUrl}${url}${query}`, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
      }),
    });
  } else {
    data = { ...data, user_id: admin_user_id };
    fetch_ = fetch(`${baseUrl}${url}`, {
      method: "POST",
      body: JSON.stringify(data), // data can be `string` or {object}!
      headers: new Headers({
        "Content-Type": "application/json",
      }),
    });
  }
  fetch_
    .then((response) => {
      if (response.status === 500) {
        handleErrorMessage(
          response.status,
          "Internal server error, please try again later",
          action,
          component,
          update_msg,
        );
        return;
      }
      if (response.status === 404) {
        try {
          response.json().then(function (object) {
            handleErrorMessage(
              response.status,
              object.msg,
              action,
              component,
              update_msg,
            );
          });
        } catch (error) {
          handleErrorMessage(
            response.status,
            "Endpoint not found",
            action,
            component,
            update_msg,
          );
        }
        return;
      }
      if (!response.ok) {
        response.json().then(function (object) {
          handleErrorMessage(
            response.status,
            object.msg,
            action,
            component,
            update_msg,
          );
        });
        return;
      }
      return response.json();
    })
    .then((response) => {
      if (response) {
        setResponseState(action, response, component, set_data, update_msg);
      }
    })
    .catch((error) => {
      console.log(error);
      handleErrorMessage(0, "Not Reachable", action, component, update_msg);
    });
};

export const getAdapter = (baseUrl, admin_user_id) => {
  const sendToServer = (...rest) =>
    rawSendToServer(baseUrl, admin_user_id, ...rest);
  const adapter = {
    async getTutorsFromPool(slug, totalBudget, component) {
      await sendToServer(
        `admin/request/${slug}/request-pool-list/`,
        "GET",
        null,
        "fetchTutors",
        component,
      );
    },
    async updateBudgetFunc(slug, budget, component) {
      await sendToServer(
        `admin/request/${slug}/update-budget/`,
        "POST",
        { new_budget: budget },
        "updateBudget",
        component,
      );
    },
    async convertBudgetFunc(slug, convertedBudget, component) {
      await sendToServer(
        `admin/request/${slug}/convert-budget/`,
        "POST",
        { new_converted_budget: convertedBudget },
        "convertBudget",
        component,
      );
    },
    async updateCurrencyFunc(slug, currency, component) {
      await sendToServer(
        `admin/request/${slug}/update-currency/`,
        "POST",
        { new_currency: currency },
        "updateCurrency",
        component,
      );
    },
    async handleToggleApprovalFunc(poolId, approval, component, updateMsg) {
      await sendToServer(
        `admin/request-pool/${poolId}/update-details/`,
        "POST",
        { approved: approval },
        "tutorApproval",
        component,
        approval,
        updateMsg,
      );
    },
    async updateSplitCount(slug, splitCount, component, updateMsg) {
      await sendToServer(
        `admin/request/${slug}/update-split/`,
        "POST",
        {
          split_count: splitCount,
        },
        "updateSplitCount",
        component,
        null,
        updateMsg,
      );
    },
    async updateAdditionalInfo(poolId, component, action, postData, updateMsg) {
      await sendToServer(
        `admin/request-pool/${poolId}/update-additional-info/`,
        "POST",
        postData,
        action,
        component,
        null,
        updateMsg,
      );
    },
    async updatePoolInstance(poolId, component, action, postData, updateMsg) {
      await sendToServer(
        `admin/request-pool/${poolId}/update-details/`,
        "POST",
        postData,
        action,
        component,
        null,
        updateMsg,
      );
    },
    async sendProfileToClient(slug, component) {
      await sendToServer(
        `admin/request/${slug}/add-tutors-client-pool`,
        "GET",
        "",
        "addTutorToClientPool",
        component,
      );
    },
  };
  return adapter;
};

export default (...rest) =>
  rawSendToServer("http://localhost:8000/", 22586, ...rest);
